module.exports = __webpack_public_path__ + "media/images/frontend/heros/home-page-top-874a407c77590e18adca8eade11b541a.jpg";